import type { FunctionComponent } from 'react';

import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import SettingsPage from '../../shared/settings/SettingsPage';
import type { RouterProps } from '../../../types';

type Props = RouterProps;

/**
 * AccountSettingsContainer is the top-level wrapper component for all the account settings pages.
 */
const AccountSettingsContainer: FunctionComponent<Props> = ({ children, location }) => (
  <SidebarNavLayout>
    <SidebarNavLayout.Nav pathname={location.pathname}>
      <SidebarNavLayout.NavHeading>
        Account
      </SidebarNavLayout.NavHeading>
      <SidebarNavLayout.NavItem to="/account/settings" activeKey="settings">
        Login
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/mfa" activeKey="mfa">
        MFA
      </SidebarNavLayout.NavItem>
    </SidebarNavLayout.Nav>
    <SidebarNavLayout.Content>
      <SettingsPage>
        {children}
      </SettingsPage>
    </SidebarNavLayout.Content>
  </SidebarNavLayout>
);

export default AccountSettingsContainer;
